<!-- 商品详情 -->

<template>
  <div class='good-detail-box'>
    <div class="container" style="width: 1380px">
      <div class="mbxie_box">
        <router-link to="/home">homepage</router-link>
        <i v-if="twoRouterName" class="el-icon-arrow-right"></i>
        <a @click="$router.back()" v-if="twoRouterName">{{ twoRouterName }}</a>
        <i class="el-icon-arrow-right" style="color: #333"></i>
        <span>Product Details</span>
      </div>

      <div class="primary_out_info_box">
        <div class="left_out_box">

          <!--          图片内容 -->
          <div class="good_img_info_out_box">
            <div class="meta_list">
              <div class="m_item_box" :class="{ cur: index == bannerActiveIndex }" v-for="(url, index) in bannerList"
                :key="index" @click="bannerActiveIndex = index">
                <img :src="url" alt="" class="pic" style="object-fit: cover">
                <!--                <div v-else class="video_box">-->
                <!--                  <img src="@/assets/images1/32.png" alt="" class="bg">-->
                <!--                  <img src="@/assets/images1/55.png" alt="" class="icon">-->
                <!--                </div>-->
              </div>
            </div>
            <div class="big_and_video_img_box">
              <img :src="bannerList[bannerActiveIndex]" alt="" style="object-fit: cover">
              <!--              <video src="" controls></video>-->
            </div>
          </div>

          <!--  详细信息-->
          <div class="good_info_out_box">
            <div class="gtt_box">Product Description</div>
            <div class="attr_tt_box">Product Attributes</div>
            <div class="line_box">
              <span>Coil</span>
              <span>{{ goodInfoData.smokeType }}</span>
            </div>
            <div class="line_box">
              <span>E-Liquid</span>
              <span>{{ goodInfoData.capacity }}</span>
            </div>
            <div class="line_box">
              <span>Puffs</span>
              <span>{{ goodInfoData.smokeNum }}</span>
            </div>
            <div class="line_box">
              <span>Battery</span>
              <span>{{ goodInfoData.battery }}</span>
            </div>
            <div class="other_box">
              <video v-if="goodInfoData.video" muted="muted" :src="goodInfoData.video" autoplay loop></video>
              <div ref="richTextContainer" class="vHTML" v-html="goodInfoData.details" />
            </div>
          </div>
        </div>

        <!--        sku信息 -->
        <div class="sku_out_box">
          <div class="big_tt_box">Model：{{ goodInfoData.name }}</div>
          <div class="attr_box">Brand：{{ goodInfoData.brandName }}</div>
          <div class="line1" />
          <div class="min_tt_box">Nicotine Salt</div>
          <div class="labels_box">
            <div class="lb_item_box" v-for="(item, index) in nicotineArr" :key="index"
              :class="{ cur: nicotineActiveIndex == index }" @click="nicotineActiveIndex = index">{{ item.content }}
            </div>
          </div>
          <div class="min_tt_box">Flavor</div>
          <div class="nums_out_box">
            <div class="no_line_box" v-for="(item, index) in flavorsArr" :key="index">
              <div class="good_info_box">
                <img :src="item.thumbnail" alt="" style="object-fit: cover">
                <div class="tt_name">{{ item.name }}</div>
              </div>
              <div class="step_box">
                <el-input-number class="sku_add_num_box" v-model="item.buyNum" :min="0"
                  :max="goodInfoData.number || 1000000" :disabled="addCarLoading"
                  @change="changeItem(item)"></el-input-number>
              </div>
            </div>
          </div>
          <!-- <div class="all_price">${{ goodInfoData.price }}</div> -->

          <div class="all_price">${{ selectNicotinePrice || goodInfoData.price }}</div>
          <div style="text-align: right;color: #e2e2e2;" v-if="denglu">Log in to check price </div>
          <div class="btns_box">
            <div class="btn_item" v-if="msShow" :loading="addCarLoading" @click="addCarSubmitFn">Add to Cart</div>
            <div class="btn_item buy" @click="quickBuy">Quick Buy</div>
          </div>
        </div>
      </div>
    </div>


    <!--  加入购物车  -->
    <el-dialog :visible.sync="isShowAddCar" width="540px" custom-class="add_car_popup" :show-close="false" top="0">
      <div class="add_car_popup_box">
        <p class="close_btn" @click="isShowAddCar = false">
          <i class="el-icon-close"></i>
        </p>

        <div class="m_tt_box">
          <div class="tname">Shopping Cart</div>
          <p class="num">
            <span>{{ carListData.length }}</span>
            <span style="margin-left: 4px">Items</span>
          </p>
        </div>

        <el-empty v-if="!carListLoading && !carListData.length" description=" " />

        <div class="dialog_car_list_box">
          <div class="line_box" v-for="(item, index) in carListData" :key="index">
            <img :src="item.thumbnail" alt="" class="picture" style="object-fit: cover">
            <div class="info_out_box">
              <div class="g_name">{{ item.name }}</div>
              <div class="g_line_box">Nicotine Content: {{ item.content }}</div>
              <div class="g_line_box">flavor:{{ item.falvorName }}</div>
              <div class="g_line_box" style="margin-top: 4px;">
                <span>Amount</span>
                <el-input-number class="add_car_step_box" v-model="item.changeNumber" :min="1"
                  :disabled="item.numChangeLoading || item.delLoading"
                  @change="carGoodNumChange(item)"></el-input-number>
              </div>
            </div>

            <div class="price_out_box">
              <div class="price_box">${{ item.price }}</div>
              <div class="remove" v-loading="item.delLoading" @click="delCarDataFn(item, index)">
                <i class="el-icon-delete"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="all">
          <span style="margin-right: 64px;">Total:</span>
          <span>${{ carAllGoodPrice }}</span>
        </div>

        <div class="btn_box">
          <div class="btn_item continue" v-loading="addCarLoading" @click="isShowAddCar = false">Continue Shopping</div>
          <div class="btn_item" @click="toCarPage">Go To Checkout</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      msShow: true,
      // 二级路由名称【未传标识首页】
      twoRouterName: "",
      buyNum: 1,
      isShowAddCar: false,
      carBuyNum: 1, // 购物车购买数量
      goodInfoData: {}, // 商品详情信息
      bannerList: [],
      bannerActiveIndex: 0,
      nicotineArr: [], // 尼古丁含量列表
      nicotineActiveIndex: 0,
      flavorsArr: [], // 口味列表
      addCarLoading: false,
      carListLoading: false,
      carListData: [],
      allPrice: 0,
      isMiaosha: false,// 是否为秒杀商品
      denglu: false,
      goodsIds: ''
    }
  },
  computed: {
    // 选中的尼古丁类型价格
    selectNicotinePrice() {
      let info = this.nicotineArr[this.nicotineActiveIndex] || {};
      return +info.price || +info.nicotinePrice || 0;
    },
    // 选中商品的总价格
    selectAllGoodPrice() {
      let count = 0;
      this.flavorsArr.map(item => {
        if (item.buyNum) count += item.buyNum * this.selectNicotinePrice;
      })
      this.allPrice = count;
      // console.warn(count, "info.price")
      return count;
    },
    // 选中商品价格【不含数量】
    selectGoodPrice() {
      let count = 0;
      this.flavorsArr.map(item => {
        if (item.buyNum) count += +this.selectNicotinePrice || 0;
      })
      return count;
    },
    // 购物车总价
    carAllGoodPrice() {
      let count = 0;
      this.carListData.map(item => {
        count += item.price * item.number;
      })
      return count.toFixed(2);
    },
  },
  created() {
    this.goodsIds = this.$route.query.goodsId;
    console.warn(this.$route.query, "this.$route.query")
    if (localStorage.getItem("GOOD_num") == '1') {
      this.msShow = false;
    }
    var token = localStorage.getItem("TIANYUE_TOKEN");
    if (!token) {
      this.hideContentForGuest();
    }
    this.twoRouterName = this.$route.query.rname || "";
    this.initGoodData();
    // this.getcarListFn()
    window.scrollTo(0, 0);
    // console.warn(localStorage.getItem("GOOD_num"), "11")
  },
  mounted() {
    this.makeImagesResponsive();
    var token = localStorage.getItem("TIANYUE_TOKEN");
    if (!token) {
      this.denglu = true;
      this.hideContentForGuest();
    } else {
      this.denglu = false;
      this.getcarListFn()
    }
    // this.twoRouterName = this.$route.query.rname || "";
    // this.initGoodData();
    // this.getcarListFn()
    // window.scrollTo(0, 0);
  },
  methods: {
    makeImagesResponsive() {
      const container = this.$refs.richTextContainer;
      const images = container.getElementsByTagName('img');

      for (let i = 0; i < images.length; i++) {
        const img = images[i];
        img.style.width = '100%'; // 设置图片最大宽度为100%  
        img.style.height = 'auto'; // 保持图片原始纵横比  
      }

      const qlideo = container.getElementsByTagName('ql-video');
      for (let i = 0; i < qlideo.length; i++) {
        const qlideos = qlideo[i];
        qlideos.style.width = '100%'; // 设置图片最大宽度为100%  
        qlideos.style.height = 'auto'; // 保持图片原始纵横比  
      }



      const videos = container.getElementsByTagName('video');

      for (let i = 0; i < videos.length; i++) {
        const video = videos[i];
        video.style.width = '100%'; // 设置图片最大宽度为100%  
        video.style.height = 'auto'; // 保持图片原始纵横比  
      }

      const iframes = container.getElementsByTagName('iframe');

      for (let i = 0; i < iframes.length; i++) {
        const iframe = iframes[i];
        iframe.style.width = '100%'; // 设置图片最大宽度为100%  
        iframe.style.height = '472px'; // 保持图片原始纵横比  
      }
    },
    changeItem(e) {
      // if(e.buyNum)
      console.warn(e, "e")
    },
    /** 快速购买 */
    quickBuy() {
      let token = localStorage.getItem("TIANYUE_TOKEN");
      if (token) {
        const falvorList = this.flavorsArr.filter(item => item.buyNum);
        // console.warn(this.flavorsArr, this.goodInfoData, "this.flavorsArr")
        // return
        if (!falvorList.length) return this.$msg("Please choose the flavor", "e");
        const _nicotineInfo = this.nicotineArr[this.nicotineActiveIndex];

        let msPrice = 0;
        let countMs = 0;
        this.flavorsArr.map(item => {
          if (item.buyNum) {
            countMs += item.buyNum * this.selectNicotinePrice;
          }
        })
        msPrice = countMs.toFixed(2);
        console.warn(msPrice, "this.msPrice");
        // return
        if (localStorage.getItem("GOOD_num") == '1') {
          // 秒杀
          sessionStorage.setItem("QUICK_BUY_DATA", JSON.stringify(
            {
              flashId: this.goodInfoData.flashId,
              allPrice: msPrice,  //订单总价格
              goodsId: this.goodInfoData.goodsId, //商品id
              smokeType: this.goodInfoData.smokeType,
              nicotineId: _nicotineInfo.nicotineId, //尼古丁id
              nicotineName: _nicotineInfo.content,
              falvorList,
            }
          ))
        } else {
          sessionStorage.setItem("QUICK_BUY_DATA", JSON.stringify(
            {
              // allPrice: this.allPrice,  //订单总价格
              allPrice: msPrice,  //订单总价格
              goodsId: this.goodInfoData.goodsId, //商品id
              smokeType: this.goodInfoData.smokeType,
              nicotineId: _nicotineInfo.nicotineId, //尼古丁id
              nicotineName: _nicotineInfo.content,
              falvorList,
            }
          ))
        }
        this.$router.push('/home/carsure?ims=' + Number(this.isMiaosha));
      } else {
        this.$router.push('/login');
      }

    },
    /** 删除购物车商品 */
    async delCarDataFn(info, index) {
      if (info.delLoading) return;
      this.$confirm('Do you want to delete the current product?', 'Prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(async () => {
        info.delLoading = true;
        try {
          await this.$DEL("system/cart/" + info.cartId);
          this.carListData.splice(index, 1);
        } catch (e) {
          this.$msg((e || {}).msg, "e")
          info.delLoading = false;
        }
      }).catch(() => {
      });
    },
    /** 去购物车页面 */
    toCarPage() {
      this.$store.commit('setCarJsonJSON', this.carListData);
      this.$router.push('/home/car');
      this.isShowAddCar = false;
    },
    /** 购物车数量改变 */
    async carGoodNumChange(info) {
      if (info.numChangeLoading || info.changeNumber == info.number) return;
      info.numChangeLoading = true;
      try {
        await this.$PUT("system/cart", { cartId: info.cartId, number: info.changeNumber - info.number })
        info.number = info.changeNumber;
      } catch (e) {
        info.changeNumber = info.number;
      }
      info.numChangeLoading = false;
    },
    /** 购物车列表 */
    async getcarListFn() {
      this.carListLoading = true;
      try {
        const res = await this.$get("system/cart/list", { pageSize: 1000 });
        this.carListData = (res.rows || []).map(item => {
          return {
            ...item,
            delLoading: false,
            numChangeLoading: false,
            changeNumber: item.number,
          }
        })
      } catch (e) {
        this.$msg((e || {}).msg || "fail", "e")
      }
      this.carListLoading = false;
    },
    /** 加入购物车 */
    async addCarSubmitFn() {
      if (!localStorage.getItem("TIANYUE_TOKEN")) return this.$router.push('/login')
      if (this.addCarLoading) return;
      if (!this.nicotineArr.length) return this.$msg("No effective nicotine types available", "e")
      const fn = async query => {
        try {
          await this.$post("system/cart", query);
        } catch (e) {
        }
      }
      const reqArr = [];
      this.flavorsArr.map(item => {
        if (item.buyNum) {
          reqArr.push(fn({
            goodsId: this.goodInfoData.goodsId,
            "number": item.buyNum, //数量
            "falvorId": item.falvorId, //口味id
            "nicotineId": this.nicotineArr[this.nicotineActiveIndex].nicotineId //尼古丁id
          }))
        }
      })
      if (!reqArr.length) return this.$msg("Please choose a flavor", "e")
      this.addCarLoading = true;

      try {
        const res = await Promise.all(reqArr)
        await this.getcarListFn();
        this.isShowAddCar = true;
        this.$msg(res.msg || "succeed")
      } catch (e) {
        this.$msg((e || {}).msg || "fail", "e")
      }
      this.addCarLoading = false;
    },
    handlerFuwenben(result) {
      result = result.replace(/<iframe /, "<iframe style=\"width:708px;height:472px;display:block;margin:0 auto;\"");
      result = result.replace(/<img /, "<img style=\"max-width:100%;display:block;margin:0 auto;\"");
      result = result.replace(/<video /, "<video style=\"max-width:100%;display:block;margin:0 auto;\"");
      return result;
    },
    async initGoodData() {
      try {
        const res11 = await this.$get('system/goods/list', {
          goodsId: this.goodsIds
        });
        console.warn(res11, "res11res11res11res11res11res11")
        const info = res11.rows[0];
        // const info = JSON.parse(localStorage.getItem("GOOD_INFO"));
        // console.warn(info, "f")
        this.goodInfoData = info;
        this.goodInfoData.details = this.handlerFuwenben(this.goodInfoData.details || "");
        // console.debug(this.goodInfoData)
        this.bannerList = [];
        // if (info.thumbnail) this.bannerList.push(info.thumbnail);
        if (info.slideshow) this.bannerList.push(...info.slideshow.split(",").filter(url => url));
        this.nicotineArr = this.goodInfoData.nicotines || [];
        this.isMiaosha = localStorage.getItem("GOOD_num") == '1';
        if (localStorage.getItem("GOOD_num") == '1') {
          // 秒杀
          this.flavorsArr = (this.goodInfoData.flavors || []).map(item => {
            return {
              falvorId: item.falvorId,
              flavorName: item.flavorName,
              thumbnail: item.flavorThumbnail,
              buyNum: 0
            }
          });
        } else {
          this.flavorsArr = (this.goodInfoData.flavors || []).map(item => {
            return { ...item, buyNum: 0 }
          });
        }

      } catch (e) {
        this.$router.replace("/home/index")
      }
    },
    hideContentForGuest() {
      const numElements = document.querySelectorAll(".all_price");
      numElements.forEach((element) => {
        element.textContent = "$***";
      });
    },
  },
}
</script>

<style lang='scss' scoped>
@import "./goodDetail.scss";
</style>
